import React, { FunctionComponent, useContext } from "react"
import { Button, Backdrop, CircularProgress, useTheme } from "@mui/material"
import { useTranslation } from "react-i18next"
import { CollectionPointsExportDialog } from "./collection-points-export-dialog"
import { CollectionPointsExportContext } from "./collection-points-export-context"

interface ICollectionPointExportButtonProps {}

export const CollectionPointExportButton: FunctionComponent<ICollectionPointExportButtonProps> = (props) => {
  const { t } = useTranslation()
  const { exportLoading, setDialogOpen } = useContext(CollectionPointsExportContext)
  const theme = useTheme()

  return (
    <>
      <Backdrop open={exportLoading} sx={{ zIndex: theme.zIndex.modal + 1 }}>
        <CircularProgress color="primary" />
      </Backdrop>
      <CollectionPointsExportDialog />
      <Button variant="contained" type="button" color="primary" onClick={() => setDialogOpen(true)}>
        {t("collection_points.export_containers")}
      </Button>
    </>
  )
}
